<template>
    <span class="card-counter" :class="counterOuterClass">
        <i :class="counterIconClass"></i><span v-if="!skill">{{value}}</span><span class="card-counter__text" v-else>{{skill}}</span>
    </span>
</template>

<script>
    export default {
        name: 'Counter',
        props: {
            skill: {
                type: String,
                required: false
            },
            value: {
                type: [Number, String],
                default: 0
            },
            kind: {
                type: String,
                default: 'like'
            }
        },
        computed: {
            counterOuterClass () {
                return '';
            },

            counterIconClass () {
                let iconClass = 'gc-icon-';
                if (this.skill && this.kind === 'level') {
                    iconClass += 'skill-' + this.skill;
                } else {
                    iconClass += this.kind;
                }

                return 'gc-icon ' + iconClass;
            }
        },

    }
</script>

<style lang="scss" scoped>
    .card-counter {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        line-height: 24px;
        height: 24px;
        margin-right: 10px;
        color: #BBBBBB;

        .gc-icon-like, .gc-icon-comment {
            opacity: 0.2;
        }

        &__text {
            text-transform: capitalize;
        }
    }
</style>
<style lang="scss">
    .card-counter-container {
        display: inline-block;
        margin-top: -5px;
    }
</style>